export enum RequestStatuses {
    Entered = "10",
    Returned = "%5",
    Approving = "20",
    Approved = "30",
    Reviewed = "40",
    SentToBank = "50",
    Canceled = "98",
    Closed = "99"
}

export const requestStatusesMapping: Record<RequestStatuses, string> = {
    [RequestStatuses.Entered]: "Entered",
    [RequestStatuses.Returned]: "Returned",
    [RequestStatuses.Approving]: "Approving",
    [RequestStatuses.Approved]: "Approved",
    [RequestStatuses.Reviewed]: "Reviewed",
    [RequestStatuses.SentToBank]: "Sent to Bank",
    [RequestStatuses.Canceled]: "Canceled",
    [RequestStatuses.Closed]: "Closed"
}